import cn from 'clsx';
import { HTMLAttributes } from 'react';

import s from './Compare.module.scss';

export interface CompareBadgeProps {
  value: string;
  status: 'up' | 'down' | 'flat';
  className?: HTMLAttributes<HTMLSpanElement>['className'];
}

function Compare({ value, status, className }: CompareBadgeProps) {
  return (
    <span className={cn(s.wrapper, className)}>
      <div className={s.icon}>
        {status === 'up' && (
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 1L7.5 7L0.5 7L4 1Z" fill="#F02828" />
          </svg>
        )}
        {status === 'down' && (
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 7L0.5 1L7.5 1L4 7Z" fill="#0F73FE" />
          </svg>
        )}
        {status === 'flat' && (
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7 4.75H1V3.25H7V4.75Z" fill="#A8AFB6" />
          </svg>
        )}
      </div>
      <span className={cn(s.text, s[status])}>{value}</span>
    </span>
  );
}

export default Compare;
